import { render } from "./add-cover-area.vue?vue&type=template&id=a880e3ec"
import script from "./add-cover-area.vue?vue&type=script&lang=js"
export * from "./add-cover-area.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__